/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/api/advertisers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List of advertisers available to affiliate */
        get: operations["GetApiAdvertisers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/advertisers/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        /** Advertiser details */
        get: operations["GetApiAdvertisersId"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/advertisers/{id}/attributes": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        /** Advertiser attributes */
        get: operations["GetApiAdvertisersIdAttributes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/advertisers/{id}/countries": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        /** Advertiser countries */
        get: operations["GetApiAdvertisersIdCountries"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/advertisers/{id}/models": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        /** Advertiser models */
        get: operations["GetApiAdvertisersIdModels"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/affiliate-advertisers/{id}": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                id: string;
            };
            cookie?: never;
        };
        /** Get advertiser settings (backlink) for affiliate */
        get: operations["GetApiAffiliateAdvertisersId"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /** Change advertiser settings (backlink) for affiliate */
        patch: operations["PatchApiAffiliateAdvertisersId"];
        trace?: never;
    };
    "/api/models": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** List of models available to affiliate */
        get: operations["GetApiModels"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/offers/loyalty-levels": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get user's loyalty program levels
         * @deprecated
         */
        get: operations["GetApiOffersLoyaltyLevels"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/offers/sub-affiliate": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get sub-affiliate URL */
        get: operations["GetApiOffersSubAffiliate"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Affiliate offer details */
        get: operations["GetApiV2Offers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Affiliate offer details */
        get: operations["GetApiV2OffersAdvertModel"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/activation": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Offer activation status */
        get: operations["GetApiV2OffersAdvertModelActivation"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/advertiser": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Offer advertiser details */
        get: operations["GetApiV2OffersAdvertModelAdvertiser"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/cpa-rates": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Get user's offers cpa rules and can use for preview */
        get: operations["GetApiV2OffersAdvertModelCpaRates"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/cpa-triggers": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Get user's offers cpa triggers for aff cabinet */
        get: operations["GetApiV2OffersAdvertModelCpaTriggers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/marketing-rules-accept": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Accept marketing rules */
        post: operations["PostApiV2OffersAdvertModelMarketingRulesAccept"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/rated-view": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Get user's offers levels */
        get: operations["GetApiV2OffersAdvertModelRatedView"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/revenue-rated-view": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /**
         * Get user's offers revenue levels
         * @deprecated
         * @description Use /api/v2/offers/{AdvertModel}/rated-view
         */
        get: operations["GetApiV2OffersAdvertModelRevenueRatedView"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/rules": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        /** Get offer rules */
        get: operations["GetOfferRules"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/rules/{section}/{locale}": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
                locale: string;
                section: string;
            };
            cookie?: never;
        };
        /** Get section content for locale */
        get: operations["GetOfferRule"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/{AdvertModel}/traffic-sources": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                AdvertModel: string;
            };
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Send traffic sources to verification */
        post: operations["PostApiV2OffersAdvertModelTrafficSources"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/activations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Offer activation status */
        get: operations["GetApiV2OffersActivations"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v2/offers/favorite": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Add offer into favourite list */
        post: operations["PostApiV2OffersFavorite"];
        /** Remove offer from favourite list */
        delete: operations["DeleteApiV2OffersFavorite"];
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/healthcheck": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Check API system status */
        get: operations["GetHealthcheck"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        ActiveTradersAttractedCondition: components["schemas"]["BaseCondition"] & {
            actualCnt: number;
            expectedCnt: number;
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "activeTradersAttracted";
        };
        Advertiser: {
            alias: string;
            description: string;
            id: number;
            links: components["schemas"]["AdvertiserLinks"];
            logo: string;
            name: string;
            platforms: string[];
            regions: string[];
            restrictionGrade: number;
            shortDescription: string;
            theme: string[];
            website: string;
        };
        AdvertiserAttribute: {
            title: string;
            type: string;
            value: string;
        };
        AdvertiserAttributesCollection: {
            data: components["schemas"]["AdvertiserAttribute"][];
        };
        AdvertiserCountriesCollection: {
            data: components["schemas"]["Country"][];
        };
        AdvertiserLinks: {
            /** @description Translation key for the link label */
            label: string;
            /** @description Translation key for the link tooltip */
            tooltip?: string;
            type: string;
            /**
             * Format: uuid
             * @description Stable link identifier
             */
            uid: string;
            url: string;
        }[];
        AdvertisersCollection: {
            data: components["schemas"]["Advertiser"][];
        };
        AffiliateAdvertiser: {
            advertiserId: number;
            affId: number;
            backlinkUrl: string;
        };
        AffiliateAdvertiserPatch: {
            backlinkUrl?: string;
        };
        AntiFraudChecksCondition: components["schemas"]["BaseCondition"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "antiFraudChecks";
        };
        BaseCondition: {
            isSatisfied: boolean;
            type: string;
        };
        Country: {
            code: string;
            name: string;
        };
        CountryCode: string;
        /** @enum {string} */
        EnumOfferLevelsCriteria: "none" | "ftd";
        Error: {
            error?: components["schemas"]["ErrorItem"];
        };
        ErrorField: {
            /** @description translation key of error */
            key?: string;
            params?: {
                [key: string]: string;
            };
        };
        ErrorItem: {
            _global?: components["schemas"]["ErrorField"];
            fields?: {
                [key: string]: components["schemas"]["ErrorField"];
            };
        };
        HealthcheckResponse: {
            alive: boolean;
        };
        KycPassedCondition: components["schemas"]["BaseCondition"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "kycPassed";
        };
        /** @deprecated */
        LoyaltyLevel: {
            /** Format: int64 */
            ftd_count: number;
            id: number;
            name: string;
        };
        /** @deprecated */
        LoyaltyLevels: {
            /** Format: int64 */
            current_ftd_count: number;
            levels: components["schemas"]["LoyaltyLevel"][];
        };
        MarketingRulesAcceptedCondition: components["schemas"]["BaseCondition"] & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "marketingRulesAccepted";
        };
        ModelsCollection: {
            data: {
                id: string;
                name: string;
            }[];
        };
        /**
         * Format: double
         * @deprecated
         */
        MoneyAmount: number;
        /** @deprecated */
        MoneyOld: {
            amount: string;
        };
        /** @deprecated */
        MoneyV4: {
            amount: components["schemas"]["MoneyAmount"];
            currency: string;
        };
        Offer: {
            advertiser: components["schemas"]["Advertiser"];
            /**
             * @deprecated
             * @description use advertiser field
             */
            advertiserId: number;
            /** @enum {string} */
            availability: "available" | "unavailable";
            criteria: components["schemas"]["EnumOfferLevelsCriteria"];
            ftdCount: number;
            icon: string;
            id: number;
            isFavorite: boolean;
            isTrial: boolean;
            links: components["schemas"]["AdvertiserLinks"];
            marketingRulesAccepted: boolean;
            model: string;
            /** @deprecated */
            name: string;
            paymentsStatus: components["schemas"]["OfferPaymentStatus"];
            rate: string;
            rateDescription: string;
            ratesConfig?: components["schemas"]["OfferRatesConfig"];
            regions: string[];
            restrictionGrade: number;
            rules: components["schemas"]["OfferRules"];
            rulesConfig?: components["schemas"]["OfferRulesConfig"];
            shortName: string;
            trafficStatus: components["schemas"]["OfferTrafficStatus"];
            version: components["schemas"]["OfferVersion"];
        };
        OfferActivation: {
            accountConditions: (components["schemas"]["KycPassedCondition"] | components["schemas"]["MarketingRulesAcceptedCondition"] | components["schemas"]["TrafficSourcesVerifiedCondition"])[];
            paymentsConditions: (components["schemas"]["ActiveTradersAttractedCondition"] | components["schemas"]["AntiFraudChecksCondition"])[];
            paymentsStatus: components["schemas"]["OfferPaymentStatus"];
            trafficStatus: components["schemas"]["OfferTrafficStatus"];
        };
        OfferActivationTrafficSourcesPost: {
            sources: components["schemas"]["OfferTrafficSources"];
        };
        OfferAdvertiser: {
            description: string;
            id: number;
            logo: string;
            name: string;
            platforms: string[];
            regions: string[];
            restrictionGrade: number;
            theme: string[];
            website: string;
        };
        OfferCpaAffiliateCategory: {
            minDepositAmount?: components["schemas"]["MoneyOld"];
            name: string;
            weight: components["schemas"]["OfferCpaCategoryWeight"];
        };
        /** @deprecated */
        OfferCpaAffiliateRate: {
            category: components["schemas"]["OfferCpaAffiliateCategory"];
            country: components["schemas"]["Country"];
            platform: components["schemas"]["OfferCpaPlatform"];
            price: components["schemas"]["MoneyOld"];
        };
        /** @deprecated */
        OfferCpaAffiliateRatesCollection: {
            categories: components["schemas"]["OfferCpaAffiliateCategory"][];
            data: components["schemas"]["OfferCpaAffiliateRate"][];
        };
        OfferCpaCategoryWeight: number;
        /** @enum {string} */
        OfferCpaPlatform: "mobile" | "desktop";
        OfferCpaTriggersResponseV2: {
            triggers: components["schemas"]["OfferCpaTriggerV2"][];
        };
        OfferCpaTriggerV2: {
            countries: components["schemas"]["CountryCode"][];
            default_price: components["schemas"]["MoneyV4"];
            deposit_amount: components["schemas"]["MoneyV4"];
            platforms: components["schemas"]["OfferCpaPlatform"][];
        };
        OfferFavourite: {
            offerId: number;
        };
        OfferPaymentStatus: components["schemas"]["SwitcherWithSuspension"];
        OfferRateConfigDynamicRates: {
            enabled: boolean;
            mode: components["schemas"]["OfferRateConfigDynamicRatesMode"];
        };
        /** @enum {string} */
        OfferRateConfigDynamicRatesMode: "with_progress" | "without_progress";
        OfferRateConfigRatesDescription: {
            enabled: boolean;
            mode: components["schemas"]["OfferRateConfigRatesDescriptionMode"];
            text: string;
        };
        /** @enum {string} */
        OfferRateConfigRatesDescriptionMode: "plain" | "editor";
        OfferRateConfigRateShort: {
            enabled: boolean;
            mode: components["schemas"]["OfferRateConfigRateShortMode"];
            text: string;
        };
        /** @enum {string} */
        OfferRateConfigRateShortMode: "plain" | "dynamic";
        OfferRatedView: {
            current_criteria_value: number;
            /** Format: double */
            current_share_percent: number;
            levels: components["schemas"]["OfferRatedViewLevel"][];
        };
        OfferRatedViewLevel: {
            criteria_value: number;
            /** Format: double */
            share_percent: number;
        };
        OfferRatesConfig: {
            dynamic_rates: components["schemas"]["OfferRateConfigDynamicRates"];
            rate_short: components["schemas"]["OfferRateConfigRateShort"];
            rates_description: components["schemas"]["OfferRateConfigRatesDescription"];
        };
        /**
         * @deprecated
         * @description Use OfferRatedView
         */
        OfferRevenueRatedView: {
            /** Format: int64 */
            current_ftd_count: number;
            /** Format: double */
            current_revenue_share_percent: number;
            levels: components["schemas"]["OfferRevenueRatedViewLevel"][];
        };
        /**
         * @deprecated
         * @description Use OfferFtdRatedView
         */
        OfferRevenueRatedViewLevel: {
            /** Format: int64 */
            ftd_count: number;
            /** Format: double */
            revenue_share_percent: number;
        };
        OfferRule: {
            locale: string;
            sections: components["schemas"]["OfferRuleSection"][];
        };
        OfferRuleItem: {
            body: string;
            section: components["schemas"]["OfferRuleSectionType"];
        };
        OfferRules: {
            appsGuidelines?: string;
            generalRestrictions?: string;
            marketingGuidelines?: string;
            negativeKeywords?: string;
            paymentTerms?: string;
            trafficTypes?: string;
        };
        OfferRulesConfig: {
            rules: components["schemas"]["OfferRulesConfigRules"];
        };
        OfferRulesConfigRules: {
            mode: components["schemas"]["OfferRulesConfigRulesMode"];
        };
        /** @enum {string} */
        OfferRulesConfigRulesMode: "editor" | "plain";
        OfferRuleSection: {
            is_populated: boolean;
            section: components["schemas"]["OfferRuleSectionType"];
        };
        /** @enum {string} */
        OfferRuleSectionType: "generalRestrictions" | "marketingGuidelines" | "trafficTypes" | "negativeKeywords" | "appsGuidelines" | "paymentTerms";
        OfferRulesResponse: {
            data: components["schemas"]["OfferRule"][];
        };
        OffersActivationsCollection: {
            data: components["schemas"]["OffersActivationsCollectionItem"][];
        };
        OffersActivationsCollectionItem: {
            offerId: number;
            paymentConditions: components["schemas"]["OfferActivation"];
        };
        OffersCollectionV2: {
            data: components["schemas"]["OfferV2"][];
        };
        OfferTrafficSources: string[];
        /** @enum {string} */
        OfferTrafficSourcesStatus: "not_verified" | "pending" | "approved" | "rejected";
        OfferTrafficStatus: components["schemas"]["SwitcherWithSuspension"];
        OfferV2: {
            advertiserId: number;
            /** @enum {string} */
            availability: "available" | "unavailable";
            criteria: components["schemas"]["EnumOfferLevelsCriteria"];
            ftdCount: number;
            id: number;
            isFavourite: boolean;
            isTrial: boolean;
            marketingRulesAccepted: boolean;
            model: string;
            /** @deprecated */
            name: string;
            paymentsStatus: components["schemas"]["OfferPaymentStatus"];
            rate: string;
            rateShort?: components["schemas"]["OfferRateConfigRateShort"];
            rules: components["schemas"]["OfferRules"];
            shortName: string;
            trafficStatus: components["schemas"]["OfferTrafficStatus"];
            version: components["schemas"]["OfferVersion"];
        };
        /** @enum {string} */
        OfferVersion: "v1" | "v2";
        SubAffiliateUrlResponse: {
            /** @description Base sub-affiliate URL for user
             *      */
            url: string;
        };
        /** @enum {string} */
        SwitcherWithSuspension: "enabled" | "disabled" | "suspended";
        TrafficSourcesVerifiedCondition: components["schemas"]["BaseCondition"] & {
            ticketId: string;
            trafficSources: string[];
            trafficSourcesStatus: components["schemas"]["OfferTrafficSourcesStatus"];
        } & {
            /**
             * @description discriminator enum property added by openapi-typescript
             * @enum {string}
             */
            type: "trafficSourcesVerified";
        };
    };
    responses: {
        /** @description Bad Request */
        Default400ErrorResponse: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description Unauthorized */
        Default401ErrorResponse: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description Forbidden */
        Default403ErrorResponse: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description Not Found */
        Default404ErrorResponse: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
        /** @description Unexpected Error */
        DefaultErrorResponse: {
            headers: {
                [name: string]: unknown;
            };
            content: {
                "application/json": components["schemas"]["Error"];
            };
        };
    };
    parameters: {
        /** @description The id of the advertiser */
        AdvertiserId: number;
        /**
         * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
         * @example exnova_revenue
         */
        AdvertModel: string;
        FilterByCountries: string[];
        /** @description Locale information */
        LocaleId: string;
        /** @description The id of the offer */
        OfferId: number;
        OffersCpaRequiredFilterByPlatform: components["schemas"]["OfferCpaPlatform"];
        OffersFilterByAdvertiserIds: number[];
        OffersFilterByAvailabilityStatus: "unavailable" | "available";
        /** @description for favourite list */
        OffersFilterByIsFavourite: boolean;
        OffersFilterByModels: string[];
        OffersFilterByRegions: string[];
        /** @description The name of the section */
        SectionId: components["schemas"]["OfferRuleSectionType"];
    };
    requestBodies: {
        AffiliateAdvertiserPatchBody: {
            content: {
                "application/json": components["schemas"]["AffiliateAdvertiserPatch"];
            };
        };
        OfferActivationTrafficSourcesPostBody: {
            content: {
                "application/json": components["schemas"]["OfferActivationTrafficSourcesPost"];
            };
        };
        OfferIdPostBody: {
            content: {
                "application/json": components["schemas"]["OfferFavourite"];
            };
        };
    };
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    GetApiAdvertisers: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdvertisersCollection"];
                };
            };
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiAdvertisersId: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the advertiser */
                id: components["parameters"]["AdvertiserId"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Advertiser"];
                };
            };
            404: components["responses"]["Default404ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiAdvertisersIdAttributes: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the advertiser */
                id: components["parameters"]["AdvertiserId"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdvertiserAttributesCollection"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiAdvertisersIdCountries: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the advertiser */
                id: components["parameters"]["AdvertiserId"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AdvertiserCountriesCollection"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiAdvertisersIdModels: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the offer */
                id: components["parameters"]["OfferId"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ModelsCollection"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiAffiliateAdvertisersId: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the advertiser */
                id: components["parameters"]["AdvertiserId"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AffiliateAdvertiser"];
                };
            };
            404: components["responses"]["Default404ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    PatchApiAffiliateAdvertisersId: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description The id of the advertiser */
                id: components["parameters"]["AdvertiserId"];
            };
            cookie?: never;
        };
        requestBody?: components["requestBodies"]["AffiliateAdvertiserPatchBody"];
        responses: {
            /** @description Success */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            404: components["responses"]["Default404ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiModels: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ModelsCollection"];
                };
            };
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiOffersLoyaltyLevels: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["LoyaltyLevels"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiOffersSubAffiliate: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Sub-affiliate URL */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SubAffiliateUrlResponse"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2Offers: {
        parameters: {
            query?: {
                advertiserIds?: components["parameters"]["OffersFilterByAdvertiserIds"];
                /** @description for favourite list */
                isFavourite?: components["parameters"]["OffersFilterByIsFavourite"];
                modelId?: components["parameters"]["OffersFilterByModels"];
                regions?: components["parameters"]["OffersFilterByRegions"];
                status?: components["parameters"]["OffersFilterByAvailabilityStatus"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OffersCollectionV2"];
                };
            };
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModel: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Offer"];
                };
            };
            404: components["responses"]["Default404ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModelActivation: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferActivation"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModelAdvertiser: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferAdvertiser"];
                };
            };
            400: components["responses"]["Default400ErrorResponse"];
            401: components["responses"]["Default401ErrorResponse"];
            404: components["responses"]["Default404ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModelCpaRates: {
        parameters: {
            query: {
                countries?: components["parameters"]["FilterByCountries"];
                platform: components["parameters"]["OffersCpaRequiredFilterByPlatform"];
            };
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferCpaAffiliateRatesCollection"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModelCpaTriggers: {
        parameters: {
            query: {
                countries?: components["parameters"]["FilterByCountries"];
                platform: components["parameters"]["OffersCpaRequiredFilterByPlatform"];
            };
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferCpaTriggersResponseV2"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    PostApiV2OffersAdvertModelMarketingRulesAccept: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModelRatedView: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferRatedView"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersAdvertModelRevenueRatedView: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferRevenueRatedView"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetOfferRules: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferRulesResponse"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            403: components["responses"]["Default403ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetOfferRule: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
                /** @description Locale information */
                locale: components["parameters"]["LocaleId"];
                /** @description The name of the section */
                section: components["parameters"]["SectionId"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OfferRuleItem"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            403: components["responses"]["Default403ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    PostApiV2OffersAdvertModelTrafficSources: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /**
                 * @description Pair offer advertiser alias + model ['revenue', 'spread', 'lot', 'cpa', 'turnover']
                 * @example exnova_revenue
                 */
                AdvertModel: components["parameters"]["AdvertModel"];
            };
            cookie?: never;
        };
        requestBody?: components["requestBodies"]["OfferActivationTrafficSourcesPostBody"];
        responses: {
            /** @description Success */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetApiV2OffersActivations: {
        parameters: {
            query?: {
                advertiserIds?: components["parameters"]["OffersFilterByAdvertiserIds"];
                modelId?: components["parameters"]["OffersFilterByModels"];
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OffersActivationsCollection"];
                };
            };
            401: components["responses"]["Default401ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    PostApiV2OffersFavorite: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: components["requestBodies"]["OfferIdPostBody"];
        responses: {
            /** @description Success */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            400: components["responses"]["Default400ErrorResponse"];
            401: components["responses"]["Default401ErrorResponse"];
            403: components["responses"]["Default403ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    DeleteApiV2OffersFavorite: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: components["requestBodies"]["OfferIdPostBody"];
        responses: {
            /** @description Success */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            400: components["responses"]["Default400ErrorResponse"];
            401: components["responses"]["Default401ErrorResponse"];
            403: components["responses"]["Default403ErrorResponse"];
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
    GetHealthcheck: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Success */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["HealthcheckResponse"];
                };
            };
            default: components["responses"]["DefaultErrorResponse"];
        };
    };
}
export enum ApiPaths {
    GetHealthcheck = "/healthcheck",
    GetApiModels = "/api/models",
    GetApiV2Offers = "/api/v2/offers",
    GetApiV2OffersAdvertModel = "/api/v2/offers/{AdvertModel}",
    GetApiV2OffersAdvertModelAdvertiser = "/api/v2/offers/{AdvertModel}/advertiser",
    GetApiV2OffersAdvertModelCpaRates = "/api/v2/offers/{AdvertModel}/cpa-rates",
    GetApiV2OffersAdvertModelCpaTriggers = "/api/v2/offers/{AdvertModel}/cpa-triggers",
    GetApiV2OffersAdvertModelRevenueRatedView = "/api/v2/offers/{AdvertModel}/revenue-rated-view",
    GetApiV2OffersAdvertModelRatedView = "/api/v2/offers/{AdvertModel}/rated-view",
    GetApiV2OffersAdvertModelActivation = "/api/v2/offers/{AdvertModel}/activation",
    GetApiV2OffersActivations = "/api/v2/offers/activations",
    PostApiV2OffersAdvertModelTrafficSources = "/api/v2/offers/{AdvertModel}/traffic-sources",
    PostApiV2OffersAdvertModelMarketingRulesAccept = "/api/v2/offers/{AdvertModel}/marketing-rules-accept",
    PostApiV2OffersFavorite = "/api/v2/offers/favorite",
    DeleteApiV2OffersFavorite = "/api/v2/offers/favorite",
    GetApiAdvertisers = "/api/advertisers",
    GetApiAdvertisersId = "/api/advertisers/{id}",
    GetApiAffiliateAdvertisersId = "/api/affiliate-advertisers/{id}",
    PatchApiAffiliateAdvertisersId = "/api/affiliate-advertisers/{id}",
    GetApiAdvertisersIdModels = "/api/advertisers/{id}/models",
    GetApiAdvertisersIdAttributes = "/api/advertisers/{id}/attributes",
    GetApiAdvertisersIdCountries = "/api/advertisers/{id}/countries",
    GetOfferRule = "/api/v2/offers/{AdvertModel}/rules/{section}/{locale}",
    GetOfferRules = "/api/v2/offers/{AdvertModel}/rules",
    GetApiOffersLoyaltyLevels = "/api/offers/loyalty-levels",
    GetApiOffersSubAffiliate = "/api/offers/sub-affiliate"
}
